/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateNftFakerRequest,
    UpdateNftFakerRequest,
} from '../models';

export interface NftFakerApiControllerCreateNtfFakerRequest {
    createNftFakerRequest: CreateNftFakerRequest;
}

export interface NftFakerApiControllerDeleteNftFakerRequest {
    address: string;
}

export interface NftFakerApiControllerUpdateNtfFakerRequest {
    walletAddress: string;
    updateNftFakerRequest: UpdateNftFakerRequest;
}

/**
 * 
 */
export class NftFakerApi extends runtime.BaseAPI {

    /**
     */
    async nftFakerApiControllerCreateNtfFakerRaw(requestParameters: NftFakerApiControllerCreateNtfFakerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.createNftFakerRequest === null || requestParameters.createNftFakerRequest === undefined) {
            throw new runtime.RequiredError('createNftFakerRequest','Required parameter requestParameters.createNftFakerRequest was null or undefined when calling nftFakerApiControllerCreateNtfFaker.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/nft-fakers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createNftFakerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async nftFakerApiControllerCreateNtfFaker(requestParameters: NftFakerApiControllerCreateNtfFakerRequest): Promise<void> {
        await this.nftFakerApiControllerCreateNtfFakerRaw(requestParameters);
    }

    /**
     */
    async nftFakerApiControllerDeleteNftFakerRaw(requestParameters: NftFakerApiControllerDeleteNftFakerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address','Required parameter requestParameters.address was null or undefined when calling nftFakerApiControllerDeleteNftFaker.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/nft-fakers/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async nftFakerApiControllerDeleteNftFaker(requestParameters: NftFakerApiControllerDeleteNftFakerRequest): Promise<void> {
        await this.nftFakerApiControllerDeleteNftFakerRaw(requestParameters);
    }

    /**
     */
    async nftFakerApiControllerUpdateNtfFakerRaw(requestParameters: NftFakerApiControllerUpdateNtfFakerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.walletAddress === null || requestParameters.walletAddress === undefined) {
            throw new runtime.RequiredError('walletAddress','Required parameter requestParameters.walletAddress was null or undefined when calling nftFakerApiControllerUpdateNtfFaker.');
        }

        if (requestParameters.updateNftFakerRequest === null || requestParameters.updateNftFakerRequest === undefined) {
            throw new runtime.RequiredError('updateNftFakerRequest','Required parameter requestParameters.updateNftFakerRequest was null or undefined when calling nftFakerApiControllerUpdateNtfFaker.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/nft-fakers/{walletAddress}`.replace(`{${"walletAddress"}}`, encodeURIComponent(String(requestParameters.walletAddress))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateNftFakerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async nftFakerApiControllerUpdateNtfFaker(requestParameters: NftFakerApiControllerUpdateNtfFakerRequest): Promise<void> {
        await this.nftFakerApiControllerUpdateNtfFakerRaw(requestParameters);
    }

}
